import { createRoute, createRouter } from "@tanstack/react-router";
import { homeRoute, rootRoute } from "./router";
import { contactsSearch } from "./pages/contacts/search";
import { ContactsListPage } from "./pages/contacts/ContactsListPage";
import { ContactFormPage } from "./pages/contacts/ContactFormPage";
import { productsSearch } from "./pages/products/search";
import { ProductsListPage } from "./pages/products/ProductsListPage";
import { ProductFormPage } from "./pages/products/ProductFormPage";
import { PriceListsPage } from "./pages/prices/PriceListsPage";
import { PriceListPage } from "./pages/prices/PriceListPage";
import { PaymentTermsPage } from "./pages/prices/PaymentTermsPage";
import { SellersPage } from "./pages/sellers/SellersPage";
import { UsersPage } from "./pages/prefs/UsersPage";
import { SellerPage } from "./pages/sellers/SellerPage";
import { StockPage } from "./pages/stock/StockPage";
import { WarehousesPage } from "./pages/stock/WarehousesPage";
import { DeletionsPage } from "./pages/prefs/DeletionsPage";
import { JobsPage } from "./pages/prefs/JobsPage";
import { ImportsPage, importsSearch } from "./pages/prefs/ImportsPage";
import { CustomFieldsPage } from "./pages/prefs/CustomFieldsPage";
import { StatusesPage } from "./pages/statuses/StatusesPage";
import { QuotesListPage } from "./pages/quotes/QuotesListPage";
import { QuoteFormPage } from "./pages/quotes/QuoteFormPage";
import { QuoteViewPage } from "./pages/quotes/QuoteViewPage";
import { SalesOrdersListPage } from "./pages/sales-orders/SalesOrdersListPage";
import { SalesOrderFormPage } from "./pages/sales-orders/SalesOrderFormPage";
import { SalesOrderViewPage } from "./pages/sales-orders/SalesOrderViewPage";
import { PayablesPage, ReceivablesPage } from "./pages/finance/TitlesListPage";
import { PayablePage, ReceivablePage } from "./pages/finance/TitlePage";
import { AccountsPage } from "./pages/finance/AccountsPage";
import { AccountPage } from "./pages/finance/AccountPage";
import { TransfersPage } from "./pages/finance/TransfersPage";
import { FinancialCategoriesPage } from "./pages/finance/FinancialCategoriesPage";
import { PaymentMethodsPage } from "./pages/finance/PaymentMethodsPage";
import { PixSettingsPage } from "./pages/pix/PixSettingsPage";
import { ApiPage } from "./pages/integrations/ApiPage";
import { CnabPage } from "./pages/bank/CnabPage";
import { ContactStatementPage, contactStatementSearch } from "./pages/bank/ContactStatementPage";
import { CertificatePage } from "./pages/fiscal/CertificatePage";
import { TaxOperationsPage } from "./pages/fiscal/TaxOperationsPage";
import { TaxOperationPage } from "./pages/fiscal/TaxOperationPage";
import { TaxWizardPage } from "./pages/fiscal/TaxWizardPage";
import { InvoicePage } from "./pages/invoices/InvoicePage";
import { PosSalesListPage } from "./pages/pos/PosSalesListPage";
import { PosSalePage } from "./pages/pos/PosSalePage";
import { CashSessionPage, CashSessionsPage } from "./pages/pos/CashSessionsPage";
import { PosSettingsPage } from "./pages/pos/PosSettingsPage";
import { InvoicesListPage } from "./pages/invoices/InvoicesListPage";
import { GnreListPage } from "./pages/gnre/GnreListPage";
import { GnrePage } from "./pages/gnre/GnrePage";
import { AccountantPage } from "./pages/accounting/AccountantPage";
import { DasMeiPage } from "./pages/accounting/DasMeiPage";
import { FiscalFilesPage } from "./pages/accounting/FiscalFilesPage";
import { BatchPage } from "./pages/logistics/BatchPage";
import { BatchesPage } from "./pages/logistics/BatchesPage";
import { LogisticsSettingsPage } from "./pages/logistics/LogisticsSettingsPage";
import { MelhorEnvioCallbackPage } from "./pages/logistics/MelhorEnvioCallbackPage";
import { MelhorEnvioSandboxConsentPage } from "./pages/logistics/MelhorEnvioSandboxConsentPage";
import { ShipmentPage } from "./pages/logistics/ShipmentPage";
import { ShipmentsPage } from "./pages/logistics/ShipmentsPage";
import {
  melhorEnvioCallbackSearch,
  melhorEnvioSandboxSearch,
  shipmentsSearch,
} from "./pages/logistics/search";
import { InboundListPage } from "./pages/inbound/InboundListPage";
import { PurchaseOrdersListPage } from "./pages/purchase-orders/PurchaseOrdersListPage";
import { PurchaseOrderFormPage } from "./pages/purchase-orders/PurchaseOrderFormPage";
import { PurchaseOrderViewPage } from "./pages/purchase-orders/PurchaseOrderViewPage";
import { ProductionOrdersListPage } from "./pages/production/ProductionOrdersListPage";
import { ProductionOrderFormPage } from "./pages/production/ProductionOrderFormPage";
import { ProductionOrderViewPage } from "./pages/production/ProductionOrderViewPage";
import { LotsPage } from "./pages/stock/LotsPage";
import { StockCountsPage } from "./pages/stock/StockCountsPage";
import { StockCountPage } from "./pages/stock/StockCountPage";
import { GroupedBillingListPage } from "./pages/grouped-billing/GroupedBillingListPage";
import { GroupedBillingNewPage } from "./pages/grouped-billing/GroupedBillingNewPage";
import { GroupedBillingViewPage } from "./pages/grouped-billing/GroupedBillingViewPage";
import { InboundPage } from "./pages/inbound/InboundPage";
import { NfeSettingsPage } from "./pages/invoices/NfeSettingsPage";
import { ContractBillingsPage } from "./pages/services/ContractBillingsPage";
import { ContractFormPage } from "./pages/services/ContractFormPage";
import { ContractsListPage } from "./pages/services/ContractsListPage";
import { ServiceOrderFormPage } from "./pages/service-orders/ServiceOrderFormPage";
import { ServiceOrderViewPage } from "./pages/service-orders/ServiceOrderViewPage";
import { ServiceOrdersListPage } from "./pages/service-orders/ServiceOrdersListPage";
import { NfseSettingsPage } from "./pages/services/NfseSettingsPage";
import { ServiceInvoicePage } from "./pages/services/ServiceInvoicePage";
import { ServiceInvoicesListPage } from "./pages/services/ServiceInvoicesListPage";
import { VoidRangePage } from "./pages/invoices/VoidRangePage";
import { MercadoLivreSettingsPage, ShopeeSettingsPage } from "./pages/marketplaces/MarketplaceSettingsPage";
import { ShopeeCallbackPage } from "./pages/marketplaces/ShopeeCallbackPage";
import { ShopeeSandboxConsentPage } from "./pages/marketplaces/ShopeeSandboxConsentPage";
import { ChannelCallbackPage } from "./pages/marketplaces/ChannelCallbackPage";
import { ChannelSandboxConsentPage } from "./pages/marketplaces/ChannelSandboxConsentPage";
import { ChannelsPage } from "./pages/marketplaces/ChannelsPage";
import { MlCallbackPage } from "./pages/marketplaces/MlCallbackPage";
import { MlSandboxConsentPage } from "./pages/marketplaces/MlSandboxConsentPage";
import { MarketplaceListingsPage } from "./pages/marketplaces/MarketplaceListingsPage";
import { MarketplaceOrdersPage } from "./pages/marketplaces/MarketplaceOrdersPage";
import {
  marketplaceSearch,
  mlCallbackSearch,
  mlSandboxSearch,
  shopeeCallbackSearch,
  shopeeSandboxSearch,
} from "./pages/marketplaces/search";
import { CommissionsPage } from "./pages/commissions/CommissionsPage";
import { CommissionStatementPage } from "./pages/commissions/CommissionStatementPage";
import { commissionsSearch } from "./pages/commissions/search";
import { CheckoutPage } from "./pages/checkout/CheckoutPage";
import { CheckoutSessionPage } from "./pages/checkout/CheckoutSessionPage";
import { PickingListPage } from "./pages/checkout/PickingListPage";
import { pickingSearch } from "./pages/checkout/search";
import { DashboardPage } from "./pages/dashboard/DashboardPage";
import { DailyPage } from "./pages/dashboard/DailyPage";
import { SalesOrdersReportPage } from "./pages/dashboard/SalesOrdersReportPage";
import { RankingPage } from "./pages/dashboard/RankingPage";
import { GoalsPage } from "./pages/dashboard/GoalsPage";
import { AbcPage } from "./pages/bi/AbcPage";
import { CustomersPage } from "./pages/bi/CustomersPage";
import { ProductsBiPage } from "./pages/bi/ProductsBiPage";
import { abcSearch, customersSearch, productsBiSearch } from "./pages/bi/search";
import { ConsolidatedPage } from "./pages/dashboard/ConsolidatedPage";
import { WhatsappPage } from "./pages/copilot/WhatsappPage";
import {
  dailySearch,
  consolidatedSearch,
  dashboardSearch,
  goalsSearch,
  rankingSearch,
  salesOrdersSearch,
} from "./pages/dashboard/search";
import { CustomReportsPage } from "./pages/reports/CustomReportsPage";
import { AgentsPage } from "./pages/agents/AgentsPage";
import { SmartProductPage } from "./pages/agents/SmartProductPage";
import { CustomReportEditorPage } from "./pages/reports/CustomReportEditorPage";
import { labelPrintSearch, reportNewSearch } from "./pages/reports/search";
import { LabelTemplatesPage } from "./pages/labels/LabelTemplatesPage";
import { LabelTemplateEditorPage } from "./pages/labels/LabelTemplateEditorPage";
import { LabelPrintPage } from "./pages/labels/LabelPrintPage";

const contactsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/contatos",
  component: ContactsListPage,
  validateSearch: contactsSearch,
});
const contactNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/contatos/novo",
  component: ContactFormPage,
});
const contactEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/contatos/$id",
  component: ContactFormPage,
});
const productsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/produtos",
  component: ProductsListPage,
  validateSearch: productsSearch,
});
const productNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/produtos/novo",
  component: ProductFormPage,
});
const productEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/produtos/$id",
  component: ProductFormPage,
});
const priceListsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/listas-de-precos",
  component: PriceListsPage,
});
const priceListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/listas-de-precos/$id",
  component: PriceListPage,
});
const paymentTermsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/condicoes-de-pagamento",
  component: PaymentTermsPage,
});
const sellersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/vendedores",
  component: SellersPage,
});
const sellerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/vendedores/$id",
  component: SellerPage,
});
const stockRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/estoque",
  component: StockPage,
});
const warehousesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/depositos",
  component: WarehousesPage,
});
const deletionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/exclusoes",
  component: DeletionsPage,
});
const jobsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/acoes",
  component: JobsPage,
});
const importsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/importacoes",
  validateSearch: importsSearch,
  component: ImportsPage,
});
const customFieldsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/campos-customizados",
  component: CustomFieldsPage,
});
const usersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/usuarios",
  component: UsersPage,
});
const statusesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/situacoes",
  component: StatusesPage,
});

const quotesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/propostas",
  component: QuotesListPage,
});
const quoteNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/propostas/novo",
  component: QuoteFormPage,
});
const quoteRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/propostas/$id",
  component: QuoteViewPage,
});
const quoteEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/propostas/$id/editar",
  component: QuoteFormPage,
});

const ordersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pedidos",
  component: SalesOrdersListPage,
});
const orderNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pedidos/novo",
  component: SalesOrderFormPage,
});
const orderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pedidos/$id",
  component: SalesOrderViewPage,
});
const orderEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pedidos/$id/editar",
  component: SalesOrderFormPage,
});

const receivablesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/contas-a-receber",
  component: ReceivablesPage,
});
const receivableRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/contas-a-receber/$id",
  component: ReceivablePage,
});
const payablesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/contas-a-pagar",
  component: PayablesPage,
});
const payableRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/contas-a-pagar/$id",
  component: PayablePage,
});
const accountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/caixas-e-bancos",
  component: AccountsPage,
});
const accountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/caixas-e-bancos/$id",
  component: AccountPage,
});
const transfersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/transferencias",
  component: TransfersPage,
});
// T2.10: remessas e retornos CNAB e ficha financeira do contato.
const cnabRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/remessas-e-retornos",
  component: CnabPage,
});
const contactStatementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/ficha-financeira/$id",
  component: ContactStatementPage,
  validateSearch: contactStatementSearch,
});
const finCategoriesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/categorias-financeiras",
  component: FinancialCategoriesPage,
});
const paymentMethodsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/formas-de-pagamento",
  component: PaymentMethodsPage,
});
const pixSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/pix",
  component: PixSettingsPage,
});
// API pública, webhooks e MCP (T3.8).
const apiIntegrationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/api",
  component: ApiPage,
});
// Certificado digital A1 (T2.1).
const certificateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/certificado-digital",
  component: CertificatePage,
});
// Naturezas de operação, regras e assistente (T2.2). `/assistente` (estático) vence `$id`.
const taxOperationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/naturezas",
  component: TaxOperationsPage,
});
const taxWizardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/naturezas/assistente",
  component: TaxWizardPage,
});
const taxOperationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/naturezas/$id",
  component: TaxOperationPage,
});
// NF-e de saída (T2.3): lista, nota (o link do sino aponta para /vendas/notas-fiscais/$id) e configuração.
const invoicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/notas-fiscais",
  component: InvoicesListPage,
});
const invoiceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/notas-fiscais/$id",
  component: InvoicePage,
});
// PDV (T3.1): vendas da frente de caixa, caixas e configuração (o PDV em si roda em /pdv, fora do layout). Os
// caminhos estáticos (`/caixas`, `/configuracao`) vencem `$id`.
const posSalesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pdv",
  component: PosSalesListPage,
});
const posSaleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pdv/$id",
  component: PosSalePage,
});
const cashSessionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pdv/caixas",
  component: CashSessionsPage,
});
const cashSessionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pdv/caixas/$id",
  component: CashSessionPage,
});
const posSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/pdv/configuracao",
  component: PosSettingsPage,
});
// Contabilidade (T3.5, RF-CTB-01/02, RF-PRF-10): Espaço Meu Contador, SPED/Sintegra e DAS MEI.
const accountantRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contabilidade/meu-contador",
  component: AccountantPage,
});
const fiscalFilesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contabilidade/arquivos-fiscais",
  component: FiscalFilesPage,
});
const dasMeiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/contabilidade/das-mei",
  component: DasMeiPage,
});
// Guias GNRE/DARE-SP (T2.11): ICMS-ST/DIFAL/FCP devidos a outra UF, geradas a partir da NF-e autorizada.
const gnreListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/gnre",
  component: GnreListPage,
});
const gnreRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/gnre/$id",
  component: GnrePage,
});
// Logística (T3.4, RF-VEN-10): objetos de postagem (Correios e Melhor Envio), remessas e integrações.
const shipmentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/logistica",
  component: ShipmentsPage,
  validateSearch: shipmentsSearch,
});
const shipmentBatchesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/logistica/remessas",
  component: BatchesPage,
});
const shipmentBatchRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/logistica/remessas/$id",
  component: BatchPage,
});
const shipmentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/logistica/$id",
  component: ShipmentPage,
});
const logisticsSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/logistica",
  component: LogisticsSettingsPage,
});
const melhorEnvioCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/logistica/melhor-envio/retorno",
  component: MelhorEnvioCallbackPage,
  validateSearch: melhorEnvioCallbackSearch,
});
const melhorEnvioSandboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/logistica/melhor-envio/sandbox",
  component: MelhorEnvioSandboxConsentPage,
  validateSearch: melhorEnvioSandboxSearch,
});
// Faturamento agrupado (T2.7): pedidos atendidos do mesmo cliente numa NF-e e/ou num conjunto de contas a receber.
const groupedBillingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/faturamento-agrupado",
  component: GroupedBillingListPage,
});
const groupedBillingNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/faturamento-agrupado/novo",
  component: GroupedBillingNewPage,
});
const groupedBillingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/financas/faturamento-agrupado/$id",
  component: GroupedBillingViewPage,
});
// Pedidos de compra e recebimento parcial (T2.6).
const purchaseOrdersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/pedidos-de-compra",
  component: PurchaseOrdersListPage,
});
const purchaseOrderNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/pedidos-de-compra/novo",
  component: PurchaseOrderFormPage,
});
const purchaseOrderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/pedidos-de-compra/$id",
  component: PurchaseOrderViewPage,
});
const purchaseOrderEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/pedidos-de-compra/$id/editar",
  component: PurchaseOrderFormPage,
});
// Ordens de produção, lotes e conferência de estoque (T3.2).
const productionOrdersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/ordens-de-producao",
  component: ProductionOrdersListPage,
});
const productionOrderNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/ordens-de-producao/novo",
  component: ProductionOrderFormPage,
});
const productionOrderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/ordens-de-producao/$id",
  component: ProductionOrderViewPage,
});
const productionOrderEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/ordens-de-producao/$id/editar",
  component: ProductionOrderFormPage,
});
const lotsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/lotes",
  component: LotsPage,
});
const stockCountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/conferencias",
  component: StockCountsPage,
});
const stockCountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/conferencias/$id",
  component: StockCountPage,
});
// Notas de entrada (T2.5): notas recebidas (DistDFe/XML), manifestação e lançamento da entrada.
const inboundListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/notas-de-entrada",
  component: InboundListPage,
});
const inboundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/suprimentos/notas-de-entrada/$id",
  component: InboundPage,
});
const nfeSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/nfe",
  component: NfeSettingsPage,
});
// Ordens de serviço (T2.9): "nova" antes de $id (o roteador prefere o segmento fixo).
const serviceOrdersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/ordens-de-servico",
  component: ServiceOrdersListPage,
});
const serviceOrderNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/ordens-de-servico/nova",
  component: ServiceOrderFormPage,
});
const serviceOrderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/ordens-de-servico/$id",
  component: ServiceOrderViewPage,
});
const serviceOrderEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/ordens-de-servico/$id/editar",
  component: ServiceOrderFormPage,
});
// Contratos, cobranças recorrentes e NFS-e (T2.8). O link do sino aponta para /servicos/notas-de-servico/$id.
const contractsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/contratos",
  component: ContractsListPage,
});
const contractNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/contratos/novo",
  component: ContractFormPage,
});
const contractRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/contratos/$id",
  component: ContractFormPage,
});
const contractBillingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/cobrancas",
  component: ContractBillingsPage,
});
const serviceInvoicesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/notas-de-servico",
  component: ServiceInvoicesListPage,
});
const serviceInvoiceNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/notas-de-servico/nova",
  component: ServiceInvoicePage,
});
const serviceInvoiceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/servicos/notas-de-servico/$id",
  component: ServiceInvoicePage,
});
const nfseSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/nfse",
  component: NfseSettingsPage,
});
// Inutilização de numeração da NF-e (T2.4).
const nfeVoidRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/fiscal/nfe/inutilizacao",
  component: VoidRangePage,
});
// Mercado Livre (T1.16): configuração, volta do OAuth (redirect_uri), consentimento do sandbox, anúncios e pedidos.
const mlSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/mercado-livre",
  component: MercadoLivreSettingsPage,
});
const mlCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/mercado-livre/retorno",
  component: MlCallbackPage,
  validateSearch: mlCallbackSearch,
});
const mlSandboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/mercado-livre/sandbox",
  component: MlSandboxConsentPage,
  validateSearch: mlSandboxSearch,
});
// Shopee (T1.17): configuração, volta da autorização da loja e autorização do sandbox.
const shopeeSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/shopee",
  component: ShopeeSettingsPage,
});
const shopeeCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/shopee/retorno",
  component: ShopeeCallbackPage,
  validateSearch: shopeeCallbackSearch,
});
const shopeeSandboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/shopee/sandbox",
  component: ShopeeSandboxConsentPage,
  validateSearch: shopeeSandboxSearch,
});
// Canais de venda (T3.3): Nuvemshop, Shopify, Magalu e Amazon — configuração, retorno genérico e consentimento simulado.
const channelsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/preferencias/integracoes/canais",
  component: ChannelsPage,
});
const channelCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/canais/$provider/retorno",
  component: ChannelCallbackPage,
});
const channelSandboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/integracoes/canais/$provider/sandbox",
  component: ChannelSandboxConsentPage,
  validateSearch: mlSandboxSearch,
});
const mlListingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/marketplace/anuncios",
  component: MarketplaceListingsPage,
  validateSearch: marketplaceSearch,
});
const mlOrdersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/marketplace/pedidos",
  component: MarketplaceOrdersPage,
  validateSearch: marketplaceSearch,
});

// Único router do app: a árvore registrada no Register é a árvore completa (FE1).
const commissionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/comissoes",
  component: CommissionsPage,
  validateSearch: commissionsSearch,
});
const commissionStatementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/comissoes/$sellerId",
  component: CommissionStatementPage,
  validateSearch: commissionsSearch,
});

const checkoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/checkout",
  component: CheckoutPage,
});
const pickingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/checkout/separacao",
  component: PickingListPage,
  validateSearch: pickingSearch,
});
const checkoutSessionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/vendas/checkout/$id",
  component: CheckoutSessionPage,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/dashboard",
  component: DashboardPage,
  validateSearch: dashboardSearch,
});
const dailyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/diario",
  component: DailyPage,
  validateSearch: dailySearch,
});
const salesReportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/pedidos",
  component: SalesOrdersReportPage,
  validateSearch: salesOrdersSearch,
});
const rankingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/vendedores-canais",
  component: RankingPage,
  validateSearch: rankingSearch,
});
// BI histórico (T3.9, RF-BI-10..12).
const abcRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/curva-abc",
  component: AbcPage,
  validateSearch: abcSearch,
});
const customersBiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/clientes",
  component: CustomersPage,
  validateSearch: customersSearch,
});
const productsBiRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/produtos",
  component: ProductsBiPage,
  validateSearch: productsBiSearch,
});
const consolidatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/consolidado",
  component: ConsolidatedPage,
  validateSearch: consolidatedSearch,
});
const goalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/metas",
  component: GoalsPage,
  validateSearch: goalsSearch,
});

const whatsappRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/whatsapp",
  component: WhatsappPage,
});

const customReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/relatorios",
  component: CustomReportsPage,
});
const customReportNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/relatorios/novo",
  component: CustomReportEditorPage,
  validateSearch: reportNewSearch,
});
const customReportRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/relatorios/$id",
  component: CustomReportEditorPage,
});
const agentsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/meu-negocio/agentes",
  component: AgentsPage,
});
const smartProductRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/cadastro-inteligente",
  component: SmartProductPage,
});
const labelTemplatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/etiquetas",
  component: LabelTemplatesPage,
});
const labelTemplateNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/etiquetas/novo",
  component: LabelTemplateEditorPage,
  validateSearch: reportNewSearch,
});
const labelPrintRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/etiquetas/imprimir",
  component: LabelPrintPage,
  validateSearch: labelPrintSearch,
});
const labelTemplateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cadastros/etiquetas/$id",
  component: LabelTemplateEditorPage,
});

export const routeTree = rootRoute.addChildren([
  apiIntegrationsRoute,
  customReportsRoute,
  customReportNewRoute,
  customReportRoute,
  agentsRoute,
  smartProductRoute,
  labelTemplatesRoute,
  labelTemplateNewRoute,
  labelPrintRoute,
  labelTemplateRoute,
  homeRoute,
  certificateRoute,
  taxOperationsRoute,
  taxWizardRoute,
  taxOperationRoute,
  invoicesRoute,
  posSalesRoute,
  posSaleRoute,
  cashSessionsRoute,
  cashSessionRoute,
  posSettingsRoute,
  invoiceRoute,
  gnreListRoute,
  accountantRoute,
  fiscalFilesRoute,
  dasMeiRoute,
  shipmentsRoute,
  shipmentBatchesRoute,
  shipmentBatchRoute,
  shipmentRoute,
  logisticsSettingsRoute,
  melhorEnvioCallbackRoute,
  melhorEnvioSandboxRoute,
  gnreRoute,
  groupedBillingsRoute,
  groupedBillingNewRoute,
  groupedBillingRoute,
  purchaseOrdersRoute,
  purchaseOrderNewRoute,
  purchaseOrderRoute,
  purchaseOrderEditRoute,
  productionOrdersRoute,
  productionOrderNewRoute,
  productionOrderRoute,
  productionOrderEditRoute,
  lotsRoute,
  stockCountsRoute,
  stockCountRoute,
  inboundListRoute,
  inboundRoute,
  nfeSettingsRoute,
  nfeVoidRoute,
  serviceOrdersRoute,
  serviceOrderNewRoute,
  serviceOrderRoute,
  serviceOrderEditRoute,
  contractsRoute,
  contractNewRoute,
  contractRoute,
  contractBillingsRoute,
  serviceInvoicesRoute,
  serviceInvoiceNewRoute,
  serviceInvoiceRoute,
  nfseSettingsRoute,
  whatsappRoute,
  dashboardRoute,
  dailyRoute,
  salesReportRoute,
  rankingRoute,
  abcRoute,
  customersBiRoute,
  productsBiRoute,
  consolidatedRoute,
  goalsRoute,
  checkoutRoute,
  pickingRoute,
  checkoutSessionRoute,
  commissionsRoute,
  commissionStatementRoute,
  contactsRoute,
  contactNewRoute,
  contactEditRoute,
  productsRoute,
  productNewRoute,
  productEditRoute,
  priceListsRoute,
  priceListRoute,
  paymentTermsRoute,
  sellersRoute,
  usersRoute,
  sellerRoute,
  stockRoute,
  warehousesRoute,
  deletionsRoute,
  jobsRoute,
  importsRoute,
  customFieldsRoute,
  statusesRoute,
  quotesRoute,
  quoteNewRoute,
  quoteRoute,
  quoteEditRoute,
  ordersRoute,
  orderNewRoute,
  orderRoute,
  orderEditRoute,
  receivablesRoute,
  receivableRoute,
  payablesRoute,
  payableRoute,
  accountsRoute,
  accountRoute,
  transfersRoute,
  cnabRoute,
  contactStatementRoute,
  finCategoriesRoute,
  paymentMethodsRoute,
  pixSettingsRoute,
  mlSettingsRoute,
  mlCallbackRoute,
  mlSandboxRoute,
  shopeeSettingsRoute,
  shopeeCallbackRoute,
  shopeeSandboxRoute,
  channelsRoute,
  channelCallbackRoute,
  channelSandboxRoute,
  mlListingsRoute,
  mlOrdersRoute,
]);
export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
